module.exports = __webpack_public_path__ + "static/img/plan2.b5db870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/doublelift/training-plan/plan2.png
// module id = 1O7c
// module chunks = 35